import $api, { request } from "@/http";
import { AvaliableBalanceTypes, LockedBalanceTypes, MinimalWithdrawAmount } from "./types";
import { useQuery } from "@tanstack/react-query";

export const useGetAvaliableBalance = () => {
    return useQuery<AvaliableBalanceTypes[], Error>({
        queryFn: async () => {
            const { data } = await $api.get('/customers/balance/available'); return data
        },
        queryKey: ['balanceAvaliable']
    });
};

export const useGetLockedBalance = () => {
    return useQuery<LockedBalanceTypes[], Error>({
        queryFn: async () => {
            const { data } = await $api.get('/customers/balance/locked'); return data
        },
        queryKey: ['balanceLocked']
    });
};

export const getAvaliableBalance = (forWithdrawal?: boolean) => {
    const url = forWithdrawal 
        ? '/customers/balance/available?for_withdrawal=true'
        : '/customers/balance/available';
    return request({
        url,
        method: 'GET'
    })
};

export const getLockedBalance = (forWithdrawal?: boolean) => {
    const url = forWithdrawal 
        ? '/customers/balance/locked?for_withdrawal=true'
        : '/customers/balance/locked';
    return request({
        url,
        method: 'GET'
    })
};

export const getCustomerProfileData = () => {
    return request({
        url: '/customers/overview',
        method: 'GET'
    })
};

export const getCustomerDocuments = (id:number) => {
    return request({
        url: `/customers/documents/${id}/view`,
        method: 'GET'
    });
};

// Функция для получения минимальных сумм вывода
export const getMinimalWithdrawAmounts = (type?: string) => {
    return request({
        url: `/withdraw/minimal/view${type ? `?type=${type}` : ''}`,
        method: 'GET'
    });
};

// React Query hook для минимальных сумм вывода
export const useGetMinimalWithdrawAmounts = (type?: string) => {
    return useQuery<MinimalWithdrawAmount[], Error>({
        queryFn: async () => {
            const response = await getMinimalWithdrawAmounts(type);
            return response.data;
        },
        queryKey: ['minimalWithdrawAmounts', type],
        enabled: true
    });
};